// biome-ignore lint/suspicious/noExplicitAny: TODO: review this suppression
export const trace = import.meta.env.DEV ? (...args: any) => console.log('[src/index]', ...args) : () => {};
